import { DownloadButton } from '@components/common/inputs/buttons/DownloadButton';
import { useAppSelector } from '@hooks/redux.hooks';
import { selectActiveSite } from '@redux/authent/authent.selectors';
import { useExportPerimeterCamerasMutation, useExportSensorConfigurationsMutation } from '@services/c2/c2.api';

export const SensorConfigurationsExportButton = () => {
  const activeSite = useAppSelector(selectActiveSite);
  const [triggerExportConfigurations, { isLoading }] = useExportSensorConfigurationsMutation();

  return (
    <DownloadButton
      label="components.sensorInstallation.exportSensors"
      downloadTrigger={() => triggerExportConfigurations({ site: activeSite!.code })}
      loading={isLoading}
    />
  );
};

export const PerimeterCamerasExportButton = () => {
  const activeSite = useAppSelector(selectActiveSite);
  const [triggerExportPerimeterCameras, { isLoading }] = useExportPerimeterCamerasMutation();

  return (
    <DownloadButton
      label="components.sensorInstallation.exportPerimeterCameras"
      downloadTrigger={() => triggerExportPerimeterCameras({ site: activeSite!.code })}
      loading={isLoading}
    />
  );
};
